module.exports = __webpack_public_path__ + "6964a057067277bb5c6a13a8f912fdeb.png";